module.exports = __webpack_public_path__ + "img/chicken_wings.a6b40a81.jpg";